<template>
  <div class="w-full flex space-x-5">
    <div class="w-full">
      <div class="mb-2 w-full text-grey-900">
        <div class="w-full font-semibold text-left title">
          Paste your responsive wistia embed code here
        </div>
        <div class="w-full text-sm h-32 text-left">
          <text-area
            v-model="embed"
            :validator="$v.embed"
            attribute="embed"
            placeholder="Paste your responsive wistia embed code here"
          />
        </div>
        <span v-if="$v.embed.$invalid" class="text-sm text-red"
          >Embed code is required.</span
        >
      </div>
      <div class="mt-6 w-full">
        <gd-button @click="emitEmbed()" primary>Save</gd-button>
      </div>
    </div>
    <div
      class="
        w-full
        border
        preview
        flex
        items-center
        justify-center
        uppercase
        bg-grey-300
        font-bold
        pointer-events-none
        preview-wrapper
      "
    >
      <div class="w-full h-full" v-if="embed">
        <iframe :srcdoc="embed" marginwidth="0" marginheight="0" frameborder="0" width="100%" height="100%"></iframe>
      </div>
      <div v-else>Preview Here</div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import GdButton from '../Button';
import TextArea from '../TextArea';
import mixins from '../../mixins';

export default {
  name: 'WistiaVideo',
  mixins: [mixins],
  props: {
    dark: {},
  },
  data() {
    return {
      embed: '',
    };
  },
  computed: {},
  validations: {
    embed: {
      required,
    },
  },
  components: {
    GdButton,
    TextArea,
  },
  mounted() {},
  methods: {
    emitEmbed() {
      this.$v.$touch();
      try {
        if (this.$v.embed.$invalid) {
          throw new Error('Invalid Data');
        }

        this.$emit('selected', {
          id: '',
          video_embed: `${this.embed}`,
          video_source: '',
        });
      } catch (err) {}
    },
  },
  watch: {},
};
</script>